import Android24 from "./Android24";
export const IconAndroid24 = Android24;

import ArrowR16 from "./ArrowR16";
export const IconArrowR16 = ArrowR16;

import ArrowRight10 from "./ArrowRight10";
export const IconArrowRight10 = ArrowRight10;

import ArrowRight14 from "./ArrowRight14";
export const IconArrowRight14 = ArrowRight14;

import Check10 from "./Check10";
export const IconCheck10 = Check10;

import Check20 from "./Check20";
export const IconCheck20 = Check20;

import Cross10 from "./Cross10";
export const IconCross10 = Cross10;

import Cross20 from "./Cross20";
export const IconCross20 = Cross20;

import Desktop50 from "./Desktop50";
export const IconDesktop50 = Desktop50;

import ExportCustom from "./ExportCustom";
export const IconExportCustom = ExportCustom;

import ExportStandard from "./ExportStandard";
export const IconExportStandard = ExportStandard;

import Ios24 from "./Ios24";
export const IconIos24 = Ios24;

import Laptop50 from "./Laptop50";
export const IconLaptop50 = Laptop50;

import Mail30 from "./Mail30";
export const IconMail30 = Mail30;

import Message30 from "./Message30";
export const IconMessage30 = Message30;

import Mobile42 from "./Mobile42";
export const IconMobile42 = Mobile42;

import Offer30 from "./Offer30";
export const IconOffer30 = Offer30;

import Question20 from "./Question20";
export const IconQuestion20 = Question20;

import Scanner30 from "./Scanner30";
export const IconScanner30 = Scanner30;

import Tablet50 from "./Tablet50";
export const IconTablet50 = Tablet50;
